"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Init = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _basis = require("basis");

var _hooks = require("../hooks");

var _components = require("../components");

var _types = require("../types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//@ts-ignore
var Init = function Init() {
  var _useInit = (0, _hooks.useInit)(),
      error = _useInit.error;

  var history = (0, _reactRouterDom.useHistory)();
  var isReady = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.state.userToken && ctx.state.guid;
  });
  (0, _react.useEffect)(function () {
    if (isReady) {
      history.push(_types.Routes.institutions);
    }
  }, [isReady, history]);
  return error ? /*#__PURE__*/_react.default.createElement(_basis.Text, null, "There was an error loading BankConnect") : /*#__PURE__*/_react.default.createElement(_components.Loading, {
    text: "Initialising BankConnect..."
  });
};

exports.Init = Init;